import React from "react";
import CrawlerSessionRecords from "../../UserLevel/Crawler Dashboard/Social Media Crawler/CrawlerSessionRecords";
// import handleLogout from "../../../API/Logout";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";


const SessionLogsVerify = ({userDetails}) => {
const { role: userRole } = useAuth();
if(!userDetails)                    {
    // Handle the case when userDetails is not available
    return <div>Loading...</div>;
  }

return (                             
    <div>
      {userRole === "ROLE_ADMIN" && <CrawlerSessionRecords />}
      {userRole === "ROLE_USER" && <Navigate to="/" />}
    </div>
  );                                                    
}



export default SessionLogsVerify;
